var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundMain1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1092,
    height: 652,
    viewBox: "0 0 1092 652",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 604L288.067 323.112C302.006 306.837 326.294 304.437 343.148 317.669L566.042 492.658C582.199 505.343 605.339 503.727 619.576 488.919L1044 47.5",
    stroke: "url(#paint0_linear_83_400)",
    strokeOpacity: 0.1,
    strokeWidth: 95,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_83_400",
    x1: 82.5,
    y1: 296,
    x2: 741.499,
    y2: 444.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AED738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CD9C2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundMain1);
export default __webpack_public_path__ + "static/media/background_main1.0826b29f639890f69ac683aa016d6a24.svg";
export { ForwardRef as ReactComponent };